export default {
	'health-certificates': 'الشهادات الصحية',
    'health-certificate': 'الشهادة الصحية',
    'add-a-health-certificate': 'إضافة شهادة صحية'
}